import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';


import { isNullOrUndefined } from '@app/util/util';
import { FrequentFlyerResponse } from '@app/entities/frequent-flyer';

declare const external_file_programs;

@Injectable()
export class FrequentFlyerProgramsService {

  constructor() { }

  public frequentFlyerPrograms(): Observable<FrequentFlyerResponse[]> {
    return of(!isNullOrUndefined(external_file_programs) ? external_file_programs : []);
  }

}
